"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPEN_DELAY = void 0;
const OPEN_DELAY = exports.OPEN_DELAY = 300;